import * as React from 'react'
import { TaskStatus } from './TaskStatus'

interface TaskStatusWrapperProps {
  children: React.ReactNode
}

export const TaskStatusWrapper: React.FC<TaskStatusWrapperProps> = ({
  children,
}) => {
  return (
    <div className="tw-relative tw-flex tw-min-h-0 tw-w-full tw-flex-col">
      <TaskStatus />
      {children}
    </div>
  )
}
